"use strict";

define('rs/models/upload',['rs/models/abstract', 'rs/errors', 'FileAPI'], function (AbstractModel, RSErrors, FileAPI) {
  var AbstractUploadModel = AbstractModel.extend({}, {
    uploadAll: function uploadAll(options) {
      var progress = null,
        _upload = null,
        i = 0,
        files = null;
      options = _.extend({}, options);
      files = options.files || [];
      delete options.files;
      if (_.isFunction(options.progress)) {
        progress = options.progress;
        delete options.progress;
      }
      options.progress = function (pr, ev, file, xhr, options) {
        progress && progress(pr / files.length + i / files.length, ev, file, xhr, options);
      };
      _upload = function upload() {
        if (i >= files.length) {
          return Promise.resolve();
        }
        return this.upload(_.extend({}, options, {
          file: files[i++]
        })).bind(this).tap(_upload);
      };
      return _upload.call(this);
    },
    getCsrfParam: function getCsrfParam() {
      return window._csrf_parameter_name + '=' + window._csrf_token;
    },
    upload: function upload(options) {
      var headers = {},
        progress = null;
      if (_.isArray(options.files)) {
        return this.uploadAll(options);
      }
      headers[window._csrf_header_name] = window._csrf_token;
      options = _.extend({}, options);
      options.url = String(options.url);
      if (options.url.indexOf('?') < 0) {
        options.url += '?' + this.getCsrfParam();
      } else {
        options.url += '&' + this.getCsrfParam();
      }
      options.files = {
        file: options.file
      };
      delete options.file;
      options.jsonp = 'iframe';
      options.headers = headers;
      if (_.isFunction(options.progress)) {
        progress = options.progress;
        delete options.progress;
      }
      options.progress = function (ev, file, xhr, options) {
        progress && progress(ev.loaded / ev.total, ev, file, xhr, options);
      };
      return new Promise(function (resolve, reject) {
        options.complete = function (err, xhr) {
          if (err) {
            reject(err);
          } else {
            resolve(xhr);
          }
        };
        var xhr = FileAPI.upload(options);
      }).bind(this).then(function (xhr) {
        return this.processResponse(JSON.parse(xhr.responseText), xhr.statusText, xhr);
      }).caught(RSErrors.APIError, function (e) {
        throw RSErrors.UploadAPIError(e);
      });
    }
  });
  return AbstractUploadModel;
});

